export enum PersonType {
    Adult = "adult",
    Any = "any",
    Child = "child",
}
